import React, {useState} from 'react';
import {Modal} from 'react-bootstrap';
import {BaseModal, ModalBodySlot, ModalHeaderSlot} from '../base-modal/base-modal';
import {FormattedMessage, useIntl} from 'react-intl';
import {ValidateErrorWrapper} from '../../Inputs/ValidateErrorWrapper';
import {InputText} from '../../Inputs/InputText';
import {AlertCustom} from '../../../modules/Auth/component/alert';
import {getValidationErrorMessage, ValidationErrorsType} from '../../../utils/utils';
import {Country} from '../../../api/DTOs/Country';
import {BootstrapColors} from '../../../../styles/bootstap-colors';
import {PartialNullable} from '../../../../types/types';

interface IModalPaymentRequestProps {
  visible: boolean;
  errors?: string | null;
  validationErrors?: ValidationErrorsType;
  country: PartialNullable<Country>;
  onChange: (key: keyof Country, value: any) => void;

  onHide(): void;

  onOkClick(): any;
}

export const ModalCreateEditCountry: React.FC<IModalPaymentRequestProps> = ({
  visible,
  errors,
  country,
  onChange,
  validationErrors,
  onHide,
  onOkClick,
}) => {
  const intl = useIntl();
  const [loading, setLoading] = useState(false);
  const handleOkClick = async () => {
    try {
      setLoading(true);
      await onOkClick();
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <BaseModal
        visible={visible}
        loading={loading}
        disabledButtons={loading}
        onSuccess={handleOkClick}
        onHide={onHide}>
        <ModalHeaderSlot>
          <Modal.Title>
            <FormattedMessage id={'COUNTRY'} />
          </Modal.Title>
        </ModalHeaderSlot>
        <ModalBodySlot>
          <form className={'form'}>
            <AlertCustom
              text={errors || ''}
              type={BootstrapColors.LIGHT_DANGER}
              iconClassName={'svg-icon-danger'}
              visible={errors != undefined}
            />

            <div className='form-group'>
              <ValidateErrorWrapper message={getValidationErrorMessage('name', validationErrors)}>
                <InputText
                  required
                  value={country.name}
                  label={intl.formatMessage({id: 'TITLE'})}
                  hasError={!!getValidationErrorMessage('name', validationErrors)}
                  classNames={'form-control py-3 px-6 mr-2'}
                  onChange={e => onChange('name', e.currentTarget.value)}
                />
              </ValidateErrorWrapper>
              <ValidateErrorWrapper message={getValidationErrorMessage('code', validationErrors)}>
                <InputText
                  required
                  value={country.code}
                  label={intl.formatMessage({id: 'COUNTRY_CODE'})}
                  hasError={!!getValidationErrorMessage('code', validationErrors)}
                  classNames={'form-control py-3 px-6 mr-2'}
                  onChange={e => onChange('code', e.currentTarget.value)}
                />
              </ValidateErrorWrapper>
            </div>
          </form>
        </ModalBodySlot>
      </BaseModal>
    </>
  );
};
